
    <h2 mat-dialog-title>Sitzung läuft ab</h2>
    <mat-dialog-content>
      <p>Ihre Sitzung ist abgelaufen. Bitte erneuern Sie Ihre Sitzung, um fortzufahren.</p>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-raised-button color="primary" (click)="onRenew()">Session erneuern</button>
    </mat-dialog-actions>
  